export const paths = {
    home: {
        path: '/',
    },
    auth: {
        register: {
            path: '/register',
        },
        login: {
            path: '/login',
        },
        resetPassword: {
            path: '/reset-password',
        },
        renewPassword: {
            path: '/renew-password',
        },
    },
    dashboard: {
        path: '/dashboard',
    },
    error: {
        notFound: {
            path: '/404',
        },
    },
    buyCard: {
        path: '/buy-card',
    },
    buyCardChecking: {
        path: '/buy-card-checking',
    },
    checkChildren: {
        path: '/check-children',
    },
    referralTree: {
        path: '/referral-tree',
    },
    admin: {
        cardRequests: {
            path: '/admin/card-requests',
        },
        withdrawRequests: {
            path: '/admin/withdraw-requests',
        },
        usersSummary: {
            path: '/admin/users/summary',
        },
        usersSearch: {
            path: '/admin/users/search',
        },
        cardDelivery: {
            path: '/admin/card-delivery',
        },
        fixReferrals: {
            path: '/admin/fix-referrals',
        },
        tapbotBulkInsert: {
            path: '/admin/tapbot-bulk-insert',
        },
    },
} as const;